import React from 'react';
import InstagramTeamApp from './components/InstagramTeamApp';
import './App.css';

function App() {
  return (
    <div className="App">
      <InstagramTeamApp />
    </div>
  );
}

export default App;
